@if (hasPerms) {
	@if (mrMessage) {
		<div class="mrMessage">{{ mrMessage }}</div>
	}
	<div class="form-grid">
		<div class="d-flex form-grid-section">
			<div class="colstat colstat-big">
				<label>{{ "patient_name" | langVal }}</label>

				<app-gen-input
					[tabindex]="$safeNavigationMigration(tabindexes?.name)"
					autocomplete="off"
					autofocus="autofocus"
					[actualObj]="patient"
					[errors]="errors"
					fieldName="name"
					title_ph_lang="patient_name"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
			@if (insert_patient_template.name_en) {
				<div class="colstat colstat-big">
					<label>{{ "name_en" | langVal }}</label>
					<app-gen-input
						[tabindex]="$safeNavigationMigration(tabindexes?.name_en)"
						className="text-left"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="name_en"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (insert_patient_template.id_number) {
				<div class="colstat colstat-small">
					<label>{{ "id_number" | langVal }}</label>
					<app-gen-input
						[tabindex]="$safeNavigationMigration(tabindexes?.id_number)"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="id_number"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (insert_patient_template.gender) {
				<div class="colstat">
					<label>{{ "gender" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="gender"
						optionsListName="gender_opts"
						(changeEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (
				insert_patient_template.payor_id && permsService?.perms?.administrative
			) {
				<div class="colstat colstat-big">
					<label>{{ "payor" | langVal }}</label>
					<app-gen-autocomplete
						#payorFuzzyInput
						title_ph_lang="payor"
						onClickClearAndShowOpts
						[tabindex]="$safeNavigationMigration(tabindexes?.payor_id)"
						[fuzzySearchableClasses]="['payors']"
						[error]="errors.payor_id"
						(chosenEvent)="choosePayor($event)"
						hasPlus
						[actualObj]="patient"
						fieldName="payor_id"
						plusLang="add_payor"
						(plusClick)="openAddPayorModal()"
					/>
				</div>
			}
		</div>
		<hr />

		@if (permsService?.perms?.administrative && permsService.owner_has_users) {
			<div class="d-flex form-grid-section">
				<div class="colstat colstat-big">
					<label>{{ "filter_sub_users" | langVal }}</label>
					<app-autocomplete-with-tags
						(chosenEvent)="updateExcludedIds($event)"
						title_ph_lang="filter_sub_users"
					/>
				</div>
				<div class="colstat-big">
					<label>{{ "first_assoc" | langVal }}</label>
					<app-autocomplete-with-tags
						(chosenEvent)="updateSubUser($event)"
						title_ph_lang="first_assoc"
						[excludeIds]="excludeIds"
						[fuzzySearchableClasses]="['sub_users']"
						[tabindex]="$safeNavigationMigration(tabindexes?.number_of_kids)"
					/>
				</div>
			</div>
			<hr />
		}
		<div class="d-flex form-grid-section">
			<!-- <div></div> -->
			<app-contactway-add
				[contactways]="contactways"
				(removeContactway)="removeContactway($event)"
				(keyupContactway)="keyupContactway($event)"
				(changeEventContactway)="validateContactwayTaken($event)"
				(fieldChange)="validateEntireForm()"
				(addContactway)="addContactway()"
				(onIdClicked)="handleIdClicked($event)"
				class="w-100"
			/>
			@if (insert_patient_template.notifiy) {
				<div class="pad-btns colstat">
					<div>
						<app-gen-button-group
							[actualObj]="patient"
							fieldName="notifiy"
							optionsListName="notifyNoOpts"
							(changeEvent)="validateEntireForm()"
						/>
					</div>
				</div>
			}

			@if (insert_patient_template.notification_default) {
				<div class="colstat">
					<label>{{ "notification_default" | langVal }}</label>
					<div>
						<app-gen-button-group
							[actualObj]="patient"
							fieldName="notification_default"
							optionsListName="notification_defaultOpts"
							(changeEvent)="validateEntireForm()"
						/>
					</div>
				</div>
			}

			<!-- <div class="pad-btns colstat">
				<app-gen-button-group
					[actualObj]="patient"
					fieldName="active"
					optionsListName="active_opts"
					(changeEvent)="validateEntireForm()"
				/>
			</div> -->

			<!-- @if(insert_patient_template.invoice_by_mail){
				<div class="col-6 col-lg-3">
					<app-gen-button-group [actualObj]="patient" fieldName="invoice_by_mail" optionsListName="invoice_by_mail_opts"
					(changeEvent)="validateEntireForm()" />
				</div>
				} -->
			@if (insert_patient_template.automatic_proforma) {
				<div class="colstat colstat-big pad-btns">
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="automatic_proforma"
						optionsListName="automatic_proforma_opts"
						(changeEvent)="validateEntireForm()"
					/>
				</div>
			}
		</div>
		<hr />
		@if (patientfields?.length) {
			<div class="d-flex gap-3 form-grid-section">
				@for (patientfield of patientfields; track patientfield) {
					<div class="col-12 col-lg-5 colstat">
						<label>{{ patientfield.name | langVal }}</label>
						@switch (patientfield.type) {
							@case ("text") {
								<app-ta-expands
									[actualObj]="patient"
									[errors]="errors"
									[fieldName]="'patientfield_id_' + patientfield.id"
									[title_ph_lang]="patientfield.name"
									(keyupEvent)="validateEntireForm()"
								/>
							}
							@case ("opts-checkbox") {
								<div
									class="d-grid gap-2"
									style="margin-inline-start: 8px; padding-top: 4px"
								>
									@for (opt of patientfield.optsArr; track opt) {
										<p class="d-flex flex-nowrap align-items-start gap-2">
											<input
												type="radio"
												[name]="'patientfield_id_' + patientfield.id"
												(click)="
													patient['patientfield_id_' + patientfield.id] =
														opt.value;
													validateEntireForm()
												"
												[checked]="
													patient['patientfield_id_' + patientfield.id] ==
													opt.value
												"
											/>
											{{ opt.value }}
										</p>
									}
								</div>
							}
							@case ("opts-btn-group") {
								<app-gen-button-group
									[actualObj]="patient"
									[fieldName]="'patientfield_id_' + patientfield.id"
									optionFieldValue="value"
									optionFieldName="value"
									[errors]="errors"
									[options]="patientfield.optsArr"
									(changeEvent)="validateEntireForm()"
								/>
							}
						}
					</div>
				}
			</div>
		}
		<div class="d-flex form-grid-section">
			@if (insert_patient_template.year_of_birth) {
				<div class="colstat colstat-small">
					<label>{{ "year_of_birth" | langVal }}</label>
					<app-gen-input
						[tabindex]="$safeNavigationMigration(tabindexes?.year_of_birth)"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="year_of_birth"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (insert_patient_template.date_of_birth) {
				<div class="colstat colstat-small">
					<label>{{ "date_of_birth" | langVal }}</label>
					<app-date-picker
						[actualObj]="patient"
						[errors]="errors"
						[addonObject]="{ after: { icon: 'calendar' } }"
						[tabindex]="$safeNavigationMigration(tabindexes?.date_of_birth)"
						(changeEvent)="validateEntireForm()"
						fieldName="date_of_birth"
						isFullYear
						startFromDecade
					/>
				</div>
			}
		</div>
		<div class="d-flex form-grid-section">
			@if (insert_patient_template.marital_status) {
				<div class="colstat colstat-small-triple">
					<label>{{ "marital_status" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="marital_status"
						optionsListName="marital_status_opts"
						(changeEvent)="validateEntireForm()"
					/>
				</div>
			}

			@if (insert_patient_template.parents_marital_status) {
				<div class="colstat colstat-small-triple">
					<label>{{ "parents_marital_status" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="parents_marital_status"
						optionsListName="parents_marital_status_opts"
						(changeEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (insert_patient_template.number_of_kids) {
				<div class="colstat colstat-small">
					<label>{{ "number_of_kids" | langVal }}</label>
					<app-gen-input
						[tabindex]="$safeNavigationMigration(tabindexes?.number_of_kids)"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="number_of_kids"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
		</div>
		<hr />
		@if (insert_patient_template.referer) {
			<div>
				<!-- style="background-color: #ebfffb"-->
				<div class="d-flex form-grid-section">
					<div class="col-12">
						<label>{{ "referers" | langVal }}</label>
					</div>
				</div>
				@for (referer of referers; track referer) {
					<div class="d-flex form-grid-section">
						<div class="col-1">
							<button
								class="btn btn-icon"
								(click)="removeReferer(referer.id)"
								icon="minus"
							></button>
						</div>
						<div class="colstat colstat-big">
							<app-gen-autocomplete
								title_ph_lang="referer"
								onClickClearAndShowOpts
								[className]="'referer_id_' + referer.id"
								[fuzzySearchableClasses]="['referers']"
								(chosenEvent)="chooseReferer(referer, $event)"
								hasPlus
								plusLang="add_referer"
								(plusClick)="modalProps = { name: 'add-referer', referer }"
							/>
						</div>
					</div>
				}
				<div class="d-flex form-grid-section">
					<div class="col-12">
						<button
							class="btn btn-icon"
							(click)="addReferer()"
							icon="plus"
						></button>
					</div>
				</div>
			</div>
			<hr />
		}

		<div class="d-flex form-grid-section">
			@if (insert_patient_template.remarks) {
				<div class="col-12">
					<label>{{ "remarks" | langVal }}</label>
					<app-wysiwyg
						[actualObj]="patient"
						fieldName="remarks"
						tabindex="-1"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
		</div>
		<div class="d-flex form-grid-section">
			@if (insert_patient_template.tags) {
				<div class="col-12">
					<app-autocomplete-with-tags
						(chosenEvent)="chooseTags($event)"
						title_ph_lang="tags"
						[hasPlus]="
							$safeNavigationMigration(permsService?.perms?.administrative)
						"
					/>
				</div>
			}
		</div>
	</div>
	<div class="modal-btns">
		<app-cancel-btn (click)="onClose.emit()" />
		<app-btn-ext
			text="add"
			[disabled]="!isFormSubmittable"
			tabindex="10"
			(clickEv)="save()"
			[isSpin]="isSaving"
		/>
		@if (hasUpdate) {
			<app-btn-ext
				text="add_draft"
				[disabled]="!isFormSubmittable"
				(clickEv)="save(true)"
				[isSpin]="isSaving"
			/>
		}
	</div>
}
@switch (modalProps?.name) {
	@case ("add-referer") {
		<app-modal-wrap
			(onClose)="handleAddRefererClose($event)"
			title="referers"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="handleAddRefererClose($event)"
				tableName="referers"
			/>
		</app-modal-wrap>
	}
	@case ("add-payor") {
		<app-modal-wrap
			(onClose)="modalProps = null; handleAddPayorClose()"
			title="payors"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; handleAddPayorClose($event)"
				tableName="payors"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-duplicate") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="confirm_duplicate"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleDuplicateApprove($event)"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
}
